"use client";
import HeadingSize from "../ui/HeadingSize";
import ResponsivePicture from "../ui/ResponsivePicture";

interface TestimonialProps {
  name: string;
  location: string;
  title: string;
  description: string;
  image: string;
}

const testimonials: TestimonialProps[] = [
  {
    name: "Neelabh Sangal (41)",
    location: "New Delhi",
    title: "Positive Results with Good Taste",
    description:
      "After a few days, I noticed that I was using fewer ciggis. The taste is great and lasts long. I'm happy with the results.",
    image: "/images/Testimonial/Neelabh-Sangal",
  },
  {
    name: "Rais Khan (25)",
    location: "Rajasthan",
    title: "The End of My<br />Smoking Habit",
    description:
      "Ryze helped me overcome cravings and quit easily. Initially, I chewed 9 gums a day, but now, after two months, 2–3 are enough for me.",
    image: "/images/Testimonial/Rais-Khan",
  },
  {
    name: "Aman Rana (26)",
    location: "Thanesar",
    title: "Worked Like a Miracle",
    description:
      "I've been chewing masala since childhood. Just two months back, I started using Ryze. Anyone who wants to change their lifestyle must try this. Cooling flavours, great results.",
    image: "/images/Testimonial/Aman-Rana",
  },
];

function TestimonialCard({
  name,
  location,
  title,
  description,
  image,
}: TestimonialProps) {
  return (
    <div className=" w-[260px] md:w-[360px]">
      <div className=" w-[260px] md:w-[360px] bg-[#f8f6f9] rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-sm min-h-[320px] sm:min-h-[380px] md:min-h-[420px] flex flex-col">
        <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
          <ResponsivePicture
            baseSrc={image}
            alt={name}
            width={80}
            height={80}
            className="w-[45px] h-[45px] sm:w-[50px] sm:h-[50px] md:w-[80px] md:h-[80px] rounded-full"
          />
          <div>
            <h3 className="font-bold text-sm sm:text-base text-[#971d1d]">
              {name}
            </h3>
            <p className="text-sm font-semibold sm:text-base text-[#971d1d]">
              {location}
            </p>
          </div>
        </div>
        <h4
          className="font-semibold text-[20px] mb-2 sm:mb-3 md:mb-4 h-[60px] sm:h-[72px] md:h-[84px] line-clamp-2 flex items-center text-[#000000]"
          dangerouslySetInnerHTML={{ __html: title }}
        ></h4>
        <p className="text-base sm:text-lg md:text-[18px] text-[#4c4c4c] leading-relaxed h-[96px] sm:h-[120px] md:h-[144px] font-semibold">
          {description}
        </p>
      </div>
    </div>
  );
}

export default function TrustedFacesSection() {
  return (
    <section className="py-10 md:py-12  lg:py-16 mx-auto bg-white ">
      <div className=" px-2 sm:px-4 md:px-6 lg:px-8">
        <div className=" text-center mb-8 sm:mb-12 md:mb-16 tracking-normal">
          <HeadingSize text="Customer reviews" />
        </div>

        <div className="flex flex-row items-center gap-5 justify-between overflow-x-auto pb-4  scrollbar-hide max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
}
